export default {
  OWNER: 0,
  MANAGER: 1,
  WORKER: 2,
};
